/**
 * Tiny admin auth helpers. Token stored in localStorage.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'momshiach_admin_token';

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY) || '';

export const setAdminToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const adminLogout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setAdminToken(data.token);
  return data.token;
};

export const verifyAdminToken = async () => {
  try {
    await adminApi.get('/admin/verify');
    return true;
  } catch {
    return false;
  }
};
